import { IMAGE_COMPONENT_NAME } from '../../../../constants/types';

export const DEFAULT_WIDGET_TYPE = IMAGE_COMPONENT_NAME;

export const SINGLE_IMAGE_MAX_FILES_ALLOWED = 1;
export const MULTIPLE_IMAGE_MAX_FILES_ALLOWED = 50;
